import { InputTypes } from "../../data-parsing/InputTypes";
import { DataTableCell } from "./DataTableCell";
import React, { useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import { ClickableInput } from "../form/ClickableInput";

export function DataTableRow({
  rowIndex,
  formRef,
  inputRef,
  callBackRef,
  dataElement,
  dataTemplate,
  colDefs,
  editRow,
  deleteRow,
  /*   videocallCallback,
   */
}) {
  const [originalData, setOriginalData] = useState(JSON.stringify(dataElement));
  const [newData, setNewData] = useState(dataElement);
  const [hasChanged, setHasChanged] = useState(false);

  function valueChangeCallBack(col, newValue) {

    console.log(`@alreylz valueChangeCallback ${JSON.stringify(col)} : ${newValue}`)
    let aux = { ...newData }; // The new state


    //Fix for visible timestamp weird behaviour that requires things in seconds
    if (newValue instanceof Date) {
      newValue = newValue.getTime()
      console.log("detected new value of data is a Date", newValue)

      const colNamesInSeconds = ["visible_timestamp"]
      if (colNamesInSeconds.includes(col.name)) {
        newValue = newValue / 1000
      }



    }


    aux[col.name] = newValue;

    setNewData(aux);
    setHasChanged(JSON.stringify(aux) !== originalData);
  }

  function extractData(col) {
    let parsedValue;
    if (dataElement[col.name] !== null && dataElement[col.name] !== undefined) {
      parsedValue = dataElement[col.name];
    } else {
      parsedValue = "";
    }

    return parsedValue;
  }


  //Here is the code that gets called on delete or save of a row
  function handleClick(e, type) {
    if (type === InputTypes.DELETE) {
      confirmAlert({
        title: "Esta acción no se puede deshacer",
        message: "¿Seguro que quieres eliminar esta fila de la tabla?",
        buttons: [
          {
            label: "No",
          },
          {
            label: "Sí",
            onClick: () => {
              deleteRow(dataElement._id, rowIndex);
            },
          },
        ],
      });
    } else if (type === InputTypes.SAVE) {
      confirmAlert({
        title: "Esta acción puede afectar a la ordenación de la tabla",
        message:
          "¿Seguro que quieres aplicar los cambios a esta fila de la tabla?",
        buttons: [
          {
            label: "No",
          },
          {
            label: "Sí",
            onClick: () => {
              console.log("newData (to be sent)", newData);
              console.log("rowIndex", rowIndex);
              editRow(newData, rowIndex);
              setOriginalData(JSON.stringify(newData));
              setHasChanged(false);
            },
          },
        ],
      });
    }
  }

  return (
    <tr id={dataElement._id}>
      {colDefs?.map((col, colIndex) => {
        let defaultValue = extractData(col);
        return (
          <td
            className="details-control" key={`${col.name}${rowIndex}`}>
            {col.type === InputTypes.DELETE ||
              col.type === InputTypes.SAVE ||
              col.type === InputTypes.PREVIEW ||
              col.type === InputTypes.REDIRECT ||
              col.type === InputTypes.VIDEOCALL ? (
              <ClickableInput
                data-id={dataElement._id}
                key={`${rowIndex}${colIndex}`}
                type={col.type}
                hasChanged={hasChanged}
                onClick={(e) => handleClick(e, col.type)}
                data={dataElement}
                dataTemplate={dataTemplate}
              /*                 videocallCallback={videocallCallback}
               */
              />
            ) : (
              <DataTableCell
                formRef={formRef}
                inputRef={inputRef}
                dataElement={newData}
                callBackRef={callBackRef}
                defaultValue={defaultValue}
                col={col}
                valueChangeCallBack={valueChangeCallBack}
              />
            )}
          </td>
        );
      })}
    </tr>
  );
}
